import axios from 'axios';

import { toast } from 'react-toastify';

import { uploadEmailMediaService } from 'services/media.service';
import { getObjectURLFromPresigned } from './formatData';

export const uploadImageCallBack = (file) => {
  return new Promise(async (resolve, reject) => {
    try {
        
      if (file) {
        const preSignedRes = await uploadEmailMediaService({
          mediaName: file?.name,
          mediaCategory: 'Bulk-Email',
          mediaType: file?.name?.split('.')?.pop()?.toLowerCase(),
        })


        if (!preSignedRes?.data?.isError) {
          const preSignedURL = preSignedRes?.data?.data?.url;

          const formData = new FormData();
          formData.append('Content-Type', file?.type);
          formData.append('file', file);

          const uploadImage = await axios.put(preSignedURL, file, {
            headers: {
              'content-type': file?.type,
              'Access-Control-Allow-Origin': '*',
            },
          });


          // if upload image is successful
          if (uploadImage.status === 200) {
            const objectURL = getObjectURLFromPresigned(preSignedURL)
            resolve({ data: { link: objectURL } });
          }
          else {
            reject('Error uploading image! Please try again.');
          }
        }
          
      }
        
    } catch (error) {
      console.error('Error uploading image:', error);
      toast.error('Sorry, could not upload Image. Please try again!', {
        toastId: `upload-image-error`,
      })
      reject(error)
    }
  })
};

export const replaceAltForImg = (content) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(content, 'text/html');

  const images = doc.querySelectorAll('img');
  if (images.length) {
    images.forEach((img) => {
      const alt = img.getAttribute('alt').trim();
      if (!alt?.length) {
        img.setAttribute('alt', 'image');
      }
    });
  }


  return doc.body.innerHTML;
};
